import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './FormConfirmation.css';

import pensif from '../assets/forms/form_emojis/hesitation.png';
import rappel from '../assets/forms/form_emojis/rappel.png';
import { ReactComponent as DropletG } from '../assets/forms/form_emojis/dropletg.svg';
import { ReactComponent as HeartG } from '../assets/forms/form_emojis/heartg.svg';
import { ReactComponent as HeartbeatG } from '../assets/forms/form_emojis/heartbeatg.svg';

const FormConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleConfirm = () => {
    navigate('/formulaire/recap', { state: location.state });
  };

  const handleBack = () => {
    navigate('/formulaire/sport');
  };

  return (
    <div className="form-confirmation">
      <div className="form-confirmation__overlay" onClick={() => navigate('/accueil')} />
      
      <div className="form-confirmation__modal">
        {/* Close button */}
        <button className="form-confirmation__close" onClick={() => navigate('/accueil')} aria-label="Fermer">✕</button>

        {/* Header avec emoji */}
        <div className="form-confirmation__header">
          <img src={pensif} alt="Pensif" className="form-confirmation__emoji" />
          <h1 className="form-confirmation__title">Confirmer l'enregistrement</h1>
          <p className="form-confirmation__subtitle">Es-tu sure de vouloir enregistrer ?</p>
        </div>

        {/* Rappel box */}
        <div className="form-confirmation__reminder">
          <img src={rappel} alt="Rappel" className="form-confirmation__reminder-icon" />
          <div className="form-confirmation__reminder-content">
            <h3 className="form-confirmation__reminder-title">Rappel</h3>
            <p className="form-confirmation__reminder-text">
              Pense bien à remplir toutes les informations importantes pour un suivi optimal de ton cycle, tes émotions et tes performances sportives.
            </p>
          </div>
        </div>

        {/* Info box */}
        <div className="form-confirmation__info">
          <p className="form-confirmation__info-text">
            Tu peux revenir modifier tes données en cliquant sur les onglets Cycle, Émotions ou Sport.
          </p>
        </div>

        {/* Tabs */}
        <div className="form-confirmation__tabs">
          <button className="form-confirmation__tab" onClick={() => navigate('/formulaire/cycle')}>
            <DropletG className="form-confirmation__tab-icon" /> Cycle
          </button>
          <button className="form-confirmation__tab" onClick={() => navigate('/formulaire/mental')}>
            <HeartG className="form-confirmation__tab-icon" /> Mental
          </button>
          <button className="form-confirmation__tab" onClick={() => navigate('/formulaire/sport')}>
            <HeartbeatG className="form-confirmation__tab-icon" /> Sport
          </button>
        </div>

        {/* Footer with action buttons */}
        <div className="form-confirmation__footer">
          <div className="form-confirmation__actions">
            <button className="form-confirmation__confirm" onClick={handleConfirm}>
              Confirmer l'enregistrement
            </button>
            <button className="form-confirmation__back" onClick={handleBack}>
              Revenir compléter mes données
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormConfirmation;
